import { render, staticRenderFns } from "./SettlementExternal.vue?vue&type=template&id=044fd7b2"
import script from "./SettlementExternal.vue?vue&type=script&lang=js"
export * from "./SettlementExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports